import { withInstall } from '../../../utils/with-install'
import Ellipse from './Ellipse.vue'

export const ElAmapEllipse = withInstall(Ellipse)
export default ElAmapEllipse
